/**
 *
 * @component 用户中心/数据看板/待办异常统计
 *
 **/
import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';
import BaseCard from '@/components/UserCenter/BaseCard';
import ECharts from '&/components/BaseECharts/index';
import { Select } from '&/components/AntdEncapsulation';
import { getItemData } from '@/api/personCenter/dataBoard';
import { barOption } from './constants';
import './TodoStatistics.scss';

function TodoStatistics(props) {
    const { defaultValue, baseParams = {}, managerOpts, dayOpts } = props;

    const [params, setParams] = useState({ div: 7, managerId: null, days: 30 });
    const [data, setData] = useState([]);

    const xAxis = [],
        delayFinish = [],
        delayNotFinish = [];

    for (const item of data) {
        xAxis.push(item['_id'].stageName);
        delayFinish.push(item.delayFinish);
        delayNotFinish.push(item.delayNotFinish);
    }

    const options = {
        ...barOption,
        color: ['#71E4B7', '#5781EE'],
        xAxis: [
            {
                type: 'category',
                data: xAxis,
                axisTick: { show: true, alignWithLabel: true, interval: 0 }, // 刻度
                splitLine: {
                    show: false, // 网格线
                },
                axisLine: {
                    // 轴线
                    show: true,
                    lineStyle: {
                        color: '#E3E7F2',
                    },
                },
                axisLabel: {
                    color: 'rgba(0, 0, 0, 0.5)',
                    show: true,
                    interval: 0,
                    rotate: -45,
                    width: 60,
                    overflow: 'truncate', //breakAll
                    height: 14,
                    margin: 5,
                    verticalAlign: 'top',
                },
            },
        ],
        series: [
            {
                name: '延期完成',
                type: 'bar',
                barWidth: 9,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: delayFinish,
            },
            {
                name: '延期未完成',
                type: 'bar',
                barGap: '25%',
                barWidth: 9,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: delayNotFinish,
            },
        ],
    };
    options.grid.bottom = 28;
    options.legend.bottom = 6;

    const canInit = !params.managerId && params.days === 30;

    useEffect(() => {
        canInit && setData(defaultValue || []);
    }, [defaultValue]);

    useEffect(() => {
        !canInit && reloadData();
    }, [baseParams.entId]);

    const first = useRef(true);
    useEffect(() => {
        !first.current && reloadData();
        first.current = false;
    }, [params]);

    const onChange = (val, key) => {
        setParams(prev => {
            const next = { ...prev };
            return {
                ...next,
                [key]: val,
            };
        });
    };

    function reloadData() {
        const PARAMS = { ...baseParams, ...params };
        if (!baseParams.entId) {
            delete PARAMS.entId; // 让axios 自带entId
        }
        getItemData(PARAMS).then(({ data }) => {
            setData(data.getNotepadException);
        });
    }

    const filterEl = (
        <>
            <Select
                onChange={e => onChange(e, 'managerId')}
                className="manager-select"
                showSearch
                filterOption={(input, option) =>
                    (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                }
                options={managerOpts}
                value={params.managerId}></Select>
            <Select
                value={params.days}
                onChange={e => onChange(e, 'days')}
                options={dayOpts}></Select>
        </>
    );

    const HISTORY = useHistory();
    const targetList = () => {
        const urlParam = new URLSearchParams('');
        params.managerId && urlParam.append('manager', params.managerId);
        params.days && urlParam.append('days', params.days);
        HISTORY.push(
            '/user-center/administrator/backlog-list?' + urlParam.toString()
        );
    };

    return (
        <BaseCard
            className="todo-statistics"
            title=" 待办异常统计"
            headerExtra={filterEl}>
            {!data.length ? (
                <Empty
                    image={
                        require('&/assets/img/userCenter/emptyydata-object.png')
                            .default
                    }
                    imageStyle={{
                        height: 160,
                    }}
                    description={
                        <div className="hint-message">暂无数据</div>
                    }></Empty>
            ) : (
                <div onClick={targetList}>
                    <ECharts height="19.75rem" option={options}></ECharts>
                </div>
            )}
        </BaseCard>
    );
}

export default TodoStatistics;
